import React from 'react';

// --- Début des 9 Icônes SVG ---

const ClockIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

const LeafIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M11 20A7 7 0 0 1 4 13q0-4.4 7-7.5c.5-.2.8-.5.8-1s-.3-.8-.8-1A10 10 0 0 0 2 13a10 10 0 0 0 10 9.8"></path>
    <path d="M12 21.8c.4-.2.8-.5 1-1a7 7 0 0 0-7-7.5q0 4.4 7 7.5c.5.2.8.5.8 1s-.3.8-.8 1A10 10 0 0 1 12 21.8Z"></path>
  </svg>
);

const FileTextIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <line x1="10" y1="9" x2="8" y2="9"></line>
  </svg>
);

const CalendarIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const HomeIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  </svg>
);

const UtensilsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"></path>
    <path d="M7 2v11"></path>
    <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"></path>
  </svg>
);

const SchoolIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="m4 6 8-4 8 4"></path>
    <path d="M6 10v5c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-5"></path>
    <path d="M6 22v-4.5l8-4 8 4V22"></path>
    <path d="M12 13.5V22"></path>
    <path d="M10 12l-8 4l8 4"></path>
    <path d="m14 12 8 4-8 4"></path>
  </svg>
);

const HeartPulseIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M21.2 8.3c.1.1.1.2.1.3v.1c0 .2-.1.4-.2.5l-3.3 3.3c-.3.3-.7.5-1.1.5h-1.2c-.5 0-1-.2-1.4-.6L11.5 10l-1.8 4.2c-.1.2-.2.4-.4.6-.2.1-.4.2-.7.2h-1.3c-.6 0-1.1-.2-1.6-.6L2.6 12.6c-.2-.2-.3-.5-.3-.8v-.1c0-.2.1-.4.2-.5l.3-.3c.2-.2.5-.3.8-.3H4c.3 0 .6.1.8.3l2 2 1.2-2.8c.1-.3.3-.5.5-.6.2-.1.5-.2.7-.2h1.3c.3 0 .5.1.7.2.2.1.4.3.5.6l1.8 4.2 2.1-2.1c.3-.3.7-.5 1.1-.5h1.2c.5 0 1 .2 1.4.6l3.3 3.3c.2.2.3.5.3.8Z"></path>
  </svg>
);

const BuildingIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
    <line x1="8" y1="6" x2="8" y2="6"></line>
    <line x1="16" y1="6" x2="16" y2="6"></line>
    <line x1="8" y1="10" x2="8" y2="10"></line>
    <line x1="16" y1="10" x2="16" y2="10"></line>
    <line x1="8" y1="14" x2="8" y2="14"></line>
    <line x1="16" y1="14" x2="16" y2="14"></line>
    <line x1="8" y1="18" x2="8" y2="18"></line>
    <line x1="16" y1="18" x2="16" y2="18"></line>
  </svg>
);

// --- Fin des Icônes SVG ---
// Données pour "Nos Engagements" - J'ai remplacé les icônes
const engagements = [
  { 
    icon: ClockIcon, // Remplacé
    title: 'Intervention rapide et discrète',
    description: 'Nous comprenons l\'urgence de votre situation et agissons avec efficacité.'
  },
  { 
    icon: LeafIcon, // Remplacé
    title: 'Produits certifiés et respectueux de l\'environnement',
    description: 'Votre sécurité et celle de l\'environnement sont notre priorité.'
  },
  { 
    icon: FileTextIcon, // Remplacé
    title: 'Attestation d\'intervention disponible sur demande',
    description: 'Pour une traçabilité et une conformité totale de nos services.'
  },
  { 
    icon: CalendarIcon, // Remplacé
    title: 'Contrats sur mesure',
    description: 'Mensuels, trimestriels ou ponctuels, selon vos besoins réels.'
  }
];

// Données pour "Pour Qui ?" - J'ai remplacé les icônes
const pourQui = [
  { name: 'Villas et Appartements', icon: HomeIcon }, // Remplacé
  { name: 'Restaurants et Cafés', icon: UtensilsIcon }, // Remplacé
  { name: 'Écoles et Crèches', icon: SchoolIcon }, // Remplacé
  { name: 'Pharmacies & Cliniques', icon: HeartPulseIcon }, // Remplacé
  { name: 'Bureaux et Commerces', icon: BuildingIcon } // Remplacé
];

// Données pour les statistiques (cohérentes avec la HeroSection)
const stats = [
  { value: '3+', label: 'Années d\'expérience' },
  { value: '1000+', label: 'Interventions réalisées' },
  { value: '100%', label: 'Produits certifiés' },
  { value: '99%', label: 'Clients satisfaits' }
];

export function AboutSection() {
  return (
    // J'ai changé l'id pour correspondre à la navigation
    <section id="engagements" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* En-tête de section - Mis à jour */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Nos Engagements & Notre Expertise
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Expertise, rapidité et respect de l'environnement sont au cœur de notre mission 
            pour vous garantir un espace sain.
          </p>
        </div>

        {/* Grille de contenu principale */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {/* Image & Texte "Pourquoi nous choisir ?" */}
          <div className="space-y-6">
            <div className="relative rounded-lg overflow-hidden shadow-lg">
              {/* Remplacé <ImageWithFallback> par <img> */}
              <img
                src="capture.jpg"
                alt="Technicien PestGuard en intervention"
                className="w-full h-80 object-contain"
                onError={(e) => e.target.src = 'https://placehold.co/600x400/2d8a4a/white?text=PestGuard'}
              />
              <div className="absolute inset-0 bg-slate-blue/20"></div>
            </div>
            
            <div>
              <h3 className="text-2xl font-semibold mb-4 text-foreground">Pourquoi nous choisir ?</h3>
              <div className="space-y-4 text-muted-foreground">
                <p>
                  PestGuard est votre entreprise experte en lutte antiparasitaire, 
                  désinfection et protection contre les nuisibles.
                </p>
                <p>
                  Nous assurons des interventions rapides, efficaces et respectueuses 
                  des normes de sécurité. Notre mission est de vous offrir des solutions 
                  sur mesure pour chaque besoin, avec un service professionnel et durable.
                </p>
              </div>
            </div>
          </div>

          {/* Nos Engagements (remplace la "Timeline") */}
          <div>
            <h3 className="text-2xl font-semibold mb-6 text-foreground">Nos Engagements Clés</h3>
            <div className="space-y-4">
              {engagements.map((item, index) => {
                const IconComponent = item.icon; // IconComponent sera ClockIcon, LeafIcon, etc.
                return (
                  <div
                    key={item.title}
                    className="flex items-start space-x-4 group p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                        <IconComponent className="w-6 h-6 text-primary" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-foreground">{item.title}</h4>
                      <p className="text-muted-foreground leading-relaxed text-sm">{item.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Section Statistiques - Remplacé <Card> par <div> */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className="text-center p-6 border-0 bg-white hover:shadow-lg transition-shadow rounded-lg" // Ajout de rounded-lg
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="text-3xl font-bold text-primary mb-2">{stat.value}</div>
              <div className="text-sm text-muted-foreground">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Section "Pour Qui ?" (remplace "Certifications") - Remplacé <Card> par <div> */}
        <div id="pour-qui">
          <h3 className="text-2xl font-semibold text-center mb-8 text-foreground">
            Pour Qui ?
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6">
            {pourQui.map((client, index) => {
              const IconComponent = client.icon; // IconComponent sera HomeIcon, UtensilsIcon, etc.
              return (
                <div
                  key={client.name}
                  className="text-center p-6 border-0 bg-white hover:shadow-lg transition-all hover:-translate-y-1 rounded-lg" // Ajout de rounded-lg
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {/* Remplacé <CardContent> par <div> */}
                  <div className="p-0">
                    <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
                      <IconComponent className="w-6 h-6 text-primary" />
                    </div>
                    <h4 className="font-semibold text-foreground text-sm">{client.name}</h4>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA en bas de page - C'est déjà un <button> HTML, donc pas de changement */}
        <div className="text-center mt-16">
          <div className="bg-slate-blue/5 rounded-lg p-8">
            <h3 className="text-xl font-semibold mb-4 text-foreground">
              Prêt à retrouver un environnement sain ?
            </h3>
            <p className="text-muted-foreground mb-6">
              Rejoignez nos clients satisfaits qui font confiance à PestGuard pour leur protection.
            </p>
            <button
              className="bg-primary hover:bg-primary/90 text-white px-8 py-3 rounded-lg font-semibold transition-colors"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Contactez-nous
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}